import { ThunkAction, ThunkDispatch } from "redux-thunk";
import * as storeTypes from "./storeTypes";
import * as storeActions from "./storeActions";
import * as tokenService from "../services/tokenService";
import * as frontService from "../services/frontService";
import { customHistory } from "../../framework/customHistory";
import { appIsUpdated, isInstanceOfIApiError } from "../services/baseService";
import { SessionState } from "../session/sessionState";
import { Translations } from "ui/Scripts/source/models/translations";
import { ITypedOption } from "../common/typedOption";

export const handleApiError = (error: any, dispatch: ThunkDispatch<storeTypes.IApplicationState, any, any>) => {
    if (isInstanceOfIApiError(error)) {
        if (error.status === 401) {
            customHistory.push("/login");
        }
        if (appIsUpdated(error.message)) {
            return;
        }
        dispatch(storeActions.showErrorMessage(error.message));
    } else {
        if (appIsUpdated(error)) {
            return;
        }
        dispatch(storeActions.showErrorMessage(error));
    }
};

// Logout
export const logout = (): ThunkAction<any, storeTypes.IApplicationState, any, any> => (dispatch, getState) => {
    tokenService.logout();
};

//Session
export const setCulture = (culture: string): ThunkAction<any, storeTypes.IApplicationState, any, any> => (dispatch, getState) => {
    dispatch(storeActions.fetchStart());
    return frontService.setCulture(culture)
        .then(
            success => {
                Translations.setCulture(culture);
                const applicationState = getState();
                const sessionState = new SessionState(applicationState.session.state);
                sessionState.culture = culture;
                dispatch(storeActions.setSessionsState(sessionState));
                dispatch(storeActions.showSuccessMessage(success.message));
                // customHistory.push("/front");
                location.reload();
            },
            error => {
                handleApiError(error, dispatch);
            })
        .finally(() => dispatch(storeActions.fetchEnd()));
};

export const saveUserParameters = (parameters: ITypedOption[]): ThunkAction<any, storeTypes.IApplicationState, any, any> => (dispatch, getState) => {
    return frontService.saveUserParameters(parameters)
        .then(
            success => {
                const applicationState = getState();
                const sessionState = new SessionState(applicationState.session.state);
                sessionState.setUserParameters(parameters);
                dispatch(storeActions.setSessionsState(sessionState));
            },
            error => {
                handleApiError(error, dispatch);
            });
};

export const refreshSessionState = (): ThunkAction<any, storeTypes.IApplicationState, any, any> => (dispatch, getState) => {
    dispatch(storeActions.fetchStart());
    return frontService.getSessionState()
        .then(
            newSessionState => {
                dispatch(storeActions.setSessionsState(new SessionState(newSessionState)));
            },
            error => {
                handleApiError(error, dispatch);
            })
        .finally(() => dispatch(storeActions.fetchEnd()));
};